import moment from 'moment';

type DiffType = 'seconds' | 'minutes' | 'hours' | 'days';

export function round(num: number, digits: number) {
  return Math.round(num * digits) / digits;
}

export function timeDiff(
  d1: Date,
  d2: Date,
  type: DiffType,
  digits: number = 2
): number {
  const milliseconds_1 = d1.getTime();
  const milliseconds_2 = d2.getTime();
  const diff = milliseconds_2 - milliseconds_1;
  const seconds = diff / 1000;
  const minutes = seconds / 60;
  const hours = minutes / 60;
  const days = hours / 24;

  switch (type) {
    case 'seconds':
      return round(seconds, digits);

    case 'minutes':
      return round(minutes, digits);

    case 'hours':
      return round(hours, digits);

    case 'days':
      return round(days, digits);

    default:
      return 0;
  }
}

export function formatBlogDate(originalDate: string): string {
  if (!originalDate) {
    return null;
  }

  return moment(originalDate).format('MMMM Do, YYYY');
}
